module.exports = __webpack_public_path__ + "static/media/steps2.fff91c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/steps2.png
// module id = 108
// module chunks = 0